import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import styled from 'styled-components';

import { ContentBanner } from '@xingternal/banner';
import { IconNotificationFilled } from '@xingternal/icons';
import { spaceS, spaceXL, spaceXS } from '@xingternal/tokens';
import { BodyCopy, Headline } from '@xingternal/typography';

type LocationState = {
  bannerMessage?: {
    title: string;
    body: string;
  };
};

const Banner = styled(ContentBanner)`
  margin-top: ${spaceXL};
  padding: ${spaceXL};
  padding-right: 40px;
`;

const Text = styled.div`
  display: flex;
`;

const Icon = styled(IconNotificationFilled)`
  flex-shrink: 0;
  margin-right: ${spaceS};
`;

const StyledHeadline = styled(Headline)`
  margin-bottom: ${spaceXS};
`;

export const VerifyEmailBanner: React.VFC = () => {
  const [message, setMessage] = useState<LocationState['bannerMessage']>();
  const history = useHistory();
  const location = useLocation<LocationState | undefined>();

  const { state: { bannerMessage } = {} } = location;

  useEffect(() => {
    if (bannerMessage) {
      // We need to save the message to React state, so we can clean the Router state
      setMessage(bannerMessage);

      // The clean is needed to not keep the state between refreshes
      history.replace({ ...location, state: undefined });
    }
  }, [bannerMessage, history, location]);

  const onClose = (): void => {
    setMessage(undefined);
  };

  return (
    <Banner show={!!message?.title} display="inline" handleOnClose={onClose}>
      <Text>
        <Icon width={24} height={24} />
        <div>
          <StyledHeadline>{message?.title}</StyledHeadline>
          <BodyCopy size="small" noMargin>
            {/* BE response contains some HTML elements */
            /* eslint-disable-next-line react/no-danger */}
            <div dangerouslySetInnerHTML={{ __html: message?.body || '' }} />
          </BodyCopy>
        </div>
      </Text>
    </Banner>
  );
};
